// Modal Functions File


// Update main image in gallery
function updateMainImage(productId, imageUrl, thumbnailElement) {
  const mainImage = document.getElementById(`main-image-${productId}`);
  if (mainImage) {
    mainImage.src = imageUrl;
  }
  
  // Update active thumbnail
  const gallery = thumbnailElement.closest('.modal-gallery-thumbnails');
  if (gallery) {
    gallery.querySelectorAll('.modal-thumbnail').forEach(thumb => {
      thumb.classList.remove('active');
    });
    thumbnailElement.classList.add('active');
  }
}

// Select variant option - FIXED
function selectVariantOption(optionElement, productId) {
  console.log('Selecting variant option for product:', productId);
  
  // Update visual selection
  const optionContainer = optionElement.closest('.modal-option-values');
  optionContainer.querySelectorAll('.modal-option-value').forEach(opt => {
    opt.classList.remove('selected');
  });
  optionElement.classList.add('selected');
  
  // Get all selected options
  const form = document.getElementById(`product-form-${productId}`);
  if (!form) {
    console.error('Product form not found for ID:', productId);
    return;
  }
  
  const optionContainers = form.querySelectorAll('.modal-product-option');
  const selectedOptions = [];
  
  optionContainers.forEach((container, index) => {
    const selected = container.querySelector('.modal-option-value.selected');
    if (selected) {
      selectedOptions[index] = selected.getAttribute('data-value');
    }
  });
  
  console.log('Selected options:', selectedOptions);
  
  // Only proceed if all options are selected
  if (selectedOptions.length === optionContainers.length) {
    // Get variant data
    const variantDataElement = document.getElementById(`ProductVariants-${productId}`);
    if (variantDataElement) {
      try {
        const variantData = JSON.parse(variantDataElement.textContent);
        
        // Find matching variant
        const matchingVariant = variantData.variants.find(variant => {
          return variant.options.every((option, index) => {
            return option === selectedOptions[index];
          });
        });
        
        if (matchingVariant) {
          // Update hidden input with selected variant ID
          const variantIdInput = form.querySelector('input[name="id"]');
          if (variantIdInput) {
            variantIdInput.value = matchingVariant.id;
            console.log('Selected variant ID:', matchingVariant.id);
          }
        } else {
          console.log('No matching variant found for selected options');
        }
      } catch (error) {
        console.error('Error parsing variant data:', error);
      }
    }
  }
}

// Add to cart from modal - FIXED TO UPDATE CART DRAWER
function addToCartFromModal(productId) {
  console.log('Adding to cart from modal, product ID:', productId);
  
  const form = document.getElementById(`product-form-${productId}`);
  if (!form) {
    console.error('Product form not found');
    return;
  }
  
  const button = form.querySelector('.modal-add-to-cart');
  const variantId = form.querySelector('input[name="id"]').value;
  const quantity = parseInt(form.querySelector('input[name="quantity"]').value || '1');
  
  console.log('Adding variant ID:', variantId, 'Quantity:', quantity);
  
  // Show loading state
  button.classList.add('loading');
  button.setAttribute('disabled', 'disabled');
  
  // Add to cart
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      items: [{
        id: variantId,
        quantity: quantity
      }]
    })
  })
  .then(response => {
    if (!response.ok) {
      return response.json().then(data => {
        throw new Error(data.description || 'Error adding to cart');
      });
    }
    return response.json();
  })
  .then(data => {
    console.log('Product added to cart successfully');
    
    // Reset button state
    button.classList.remove('loading');
    button.removeAttribute('disabled');
    button.textContent = 'Added!';
    
    setTimeout(() => {
      button.textContent = 'Add to Cart';
    }, 2000);
    
    // Close modal
    closeModal();
    
    // FIXED: Better cart drawer update
    refreshCartDrawer();
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
    
    // Reset button state
    button.classList.remove('loading');
    button.removeAttribute('disabled');
    button.textContent = 'Error';
    
    setTimeout(() => {
      button.textContent = 'Add to Cart';
    }, 2000);
  });
}

// FIXED: Better cart drawer refresh method
function refreshCartDrawer() {
  // Method 1: Dawn theme approach
  fetch('/?sections=cart-drawer,cart-icon-bubble')
    .then(response => response.json())
    .then(sections => {
      // Update cart drawer content
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents({ sections: sections });
        
        // Try to open the drawer
        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
      } else {
        // Method 2: If Method 1 fails, try direct approach
        const cartIconBubble = document.querySelector('#cart-icon-bubble');
        if (cartIconBubble) {
          cartIconBubble.click();
        }
      }
    })
    .catch(error => {
      console.error('Error refreshing cart drawer:', error);
      
      // Fallback: Try direct click
      const cartIconBubble = document.querySelector('#cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.click();
      }
    });
}

// Buy now functionality for section
function buyNowFromSection(productId) {
  console.log('Buy now from section, product ID:', productId);
  
  const form = document.getElementById(`product-form-${productId}`);
  if (!form) {
    console.error('Product form not found');
    return;
  }
  
  const button = form.querySelector('.modal-buy-now');
  const variantId = form.querySelector('input[name="id"]').value;
  const quantity = parseInt(form.querySelector('input[name="quantity"]').value || '1');
  
  // Show loading state
  button.classList.add('loading');
  button.setAttribute('disabled', 'disabled');
  
  // Clear cart then add item
  fetch(window.Shopify.routes.root + 'cart/clear.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(() => {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: quantity
        }]
      })
    });
  })
  .then(response => {
    if (!response.ok) {
      return response.json().then(data => {
        throw new Error(data.description || 'Error processing request');
      });
    }
    return response.json();
  })
  .then(data => {
    // Redirect to checkout
    window.location.href = window.Shopify.routes.root + 'checkout';
  })
  .catch(error => {
    console.error('Error processing buy now:', error);
    
    // Reset button state
    button.classList.remove('loading');
    button.removeAttribute('disabled');
    button.textContent = 'Error';
    
    setTimeout(() => {
      button.textContent = 'Buy Now';
    }, 2000);
  });
}

// Modal Interactions

async function openProductModal(handle, id) {
    const modal = document.querySelector("#productModal");
    const modalContent = modal.querySelector("#modalContent");

    // Show loading state
    modalContent.innerHTML = `<p>Loading...</p>`;

    // Fetch and parse the product page
    const html = await fetchProductPage(handle);
    if (!html) {
        modalContent.innerHTML = `<p>Failed to load product information. Please try again.</p>`;
        return;
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    // Try to get the product modal section
    const productModalSection = doc.querySelector(`#product-modal-${id}`);

    if (productModalSection) {
        // Inject fetched section
        modalContent.innerHTML = productModalSection.innerHTML;
    } else {
        // If section not found, show fallback message
        modalContent.innerHTML = `<p>Product details not available.</p>`;
        console.warn(`No element found with id #product-modal-${id}`);
    }
    document.documentElement.classList.add("no-scroll"); // html
    document.body.classList.add("no-scroll");            // body
    attachModalListeners();
    modal.showModal();
}

async function fetchProductPage(handle) {
    try {
        const response = await fetch(`/products/${handle}`);
        if (!response.ok) throw new Error('Product not found or network error');
        const html = await response.text();
        return html;
    } catch (error) {
        console.error('Error fetching product page:', error);
        return null;
    }
}

function closeModal() {
  const modal = document.querySelector("#productModal");
  const modalContent = modal.querySelector("#modalContent");
  modalContent.innerHTML = "";
  modal.close();
  document.documentElement.classList.remove("no-scroll");
  document.body.classList.remove("no-scroll");
}

// Attaching Modal Listeners
function attachModalListeners() {
  let container = document.querySelector(".modal-product-container");
  container.querySelector(".modal-add-to-cart").addEventListener("click", (event)=> {
    let id = event.target.getAttribute("data-id");
    addToCartFromModal(id);
  });
}